import React from 'react';
import { MenuList } from '@material-ui/core';
import {SidebarItemComponent, SidebarAccordionComponent, ISidebarListComponent} from '@app/components';
import { IMenuItem, mainMenu, mainMenuTop } from '@app/components/Sidebar/menuObject';
import { hasMenuPermissionRoot } from '@app/helpers/permissions';
import { Scrollbars } from 'react-custom-scrollbars';

const mapMenu = (menu: IMenuItem[], setIsCollapsed: (isCollapsed: boolean) => void, isCollapsed: boolean): JSX.Element[] => {
    return menu.map((menuItem: IMenuItem, index: number) => {
        if (!menuItem.requiresPermission || hasMenuPermissionRoot(menuItem)) {
            if (isCollapsed) {

            }
            if (menuItem.isParent) {
                return <SidebarAccordionComponent key={index} menuItem={menuItem} setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} />;
            }
            return <SidebarItemComponent key={index} item={menuItem} setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} />;
        }
        return <div key={index} />;
    });
};

export const SidebarListComponent = ({ isCollapsed, setIsCollapsed }: ISidebarListComponent) => {
    const renderView = (props: any) => {
        return (
            <div {...props} className='sidebar__scroll-view'/>
        );
    };

    const renderThumbVertical = (props: any) => {
        return (
            <div {...props} className='sidebar__scroll-vertical'/>
        );
    };

    return (
        <>
            <MenuList className='sidebar__list'>{mapMenu(mainMenuTop, setIsCollapsed, isCollapsed)}</MenuList>
            <Scrollbars
                renderThumbVertical={renderThumbVertical}
                renderView={renderView}
            >
                <MenuList>{mapMenu(mainMenu, setIsCollapsed, isCollapsed)}</MenuList>
            </Scrollbars>
        </>
    );
};
